"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.detectIncognito = detectIncognito;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/*!
 *
 * detectIncognito v1.6.2
 *
 * https://github.com/Joe12387/detectIncognito
 *
 * MIT License
 *
 * Copyright (c) 2021 - 2025 Joe Rutkowski <Joe@dreggle.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * Please keep this comment intact in order to properly abide by the MIT License.
 *
 **/
function detectIncognito() {
  return _detectIncognito.apply(this, arguments);
}
function _detectIncognito() {
  _detectIncognito = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    return _regenerator["default"].wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 1;
          return new Promise(function (resolve, reject) {
            var browserName = 'Unknown';
            var callbackSettled = false;
            function __callback(isPrivate) {
              if (callbackSettled) {
                return;
              }
              callbackSettled = true;
              resolve({
                isPrivate: isPrivate,
                browserName: browserName
              });
            }
            function identifyChromium() {
              var ua = navigator.userAgent;
              if (ua.match(/Chrome/)) {
                if (navigator.brave !== undefined) {
                  return 'Brave';
                } else if (ua.match(/Edg/)) {
                  return 'Edge';
                } else if (ua.match(/OPR/)) {
                  return 'Opera';
                }
                return 'Chrome';
              } else {
                return 'Chromium';
              }
            }
            function feid() {
              var toFixedEngineID = 0;
              var neg = parseInt("-1");
              try {
                neg.toFixed(neg);
              } catch (e) {
                toFixedEngineID = e.message.length;
              }
              return toFixedEngineID;
            }
            function isSafari() {
              return feid() === 44 || feid() === 43;
            }
            function isChrome() {
              return feid() === 51;
            }
            function isFirefox() {
              return feid() === 25;
            }
            function isMSIE() {
              return navigator.msSaveBlob !== undefined;
            }

            /**
             * Safari (Safari for iOS & macOS)
             **/
            function currentSafariTest() {
              return _currentSafariTest.apply(this, arguments);
            }
            function _currentSafariTest() {
              _currentSafariTest = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
                var message, matchesExpectedError, _t;
                return _regenerator["default"].wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 1;
                      return navigator.storage.getDirectory();
                    case 1:
                      __callback(false);
                      _context.next = 3;
                      break;
                    case 2:
                      _context.prev = 2;
                      _t = _context["catch"](0);
                      message = _t instanceof Error && typeof _t.message === 'string' ? _t.message : String(_t);
                      matchesExpectedError = message.includes('unknown transient reason');
                      __callback(matchesExpectedError);
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[0, 2]]);
              }));
              return _currentSafariTest.apply(this, arguments);
            }
            function safari13to18Test() {
              var tmp = String(Math.random());
              try {
                var dbReq = indexedDB.open(tmp, 1);
                dbReq.onupgradeneeded = function (ev) {
                  var db = ev.target.result;
                  var finish = function finish(priv) {
                    __callback(priv);
                  };
                  try {
                    db.createObjectStore('t', {
                      autoIncrement: true
                    }).put(new Blob());
                    finish(false);
                  } catch (err) {
                    var message = err instanceof Error && typeof err.message === 'string' ? err.message : String(err);
                    if (message.includes('are not yet supported')) finish(true);else finish(false);
                  } finally {
                    db.close();
                    indexedDB.deleteDatabase(tmp);
                  }
                };
                dbReq.onerror = function () {
                  return __callback(false);
                };
              } catch (_unused) {
                __callback(false);
              }
            }
            function oldSafariTest() {
              var openDB = window.openDatabase;
              var storage = window.localStorage;
              try {
                openDB(null, null, null, null);
              } catch (e) {
                __callback(true);
                return;
              }
              try {
                storage.setItem('test', '1');
                storage.removeItem('test');
              } catch (e) {
                __callback(true);
                return;
              }
              __callback(false);
            }
            function safariPrivateTest() {
              return _safariPrivateTest.apply(this, arguments);
            }
            /**
             * Chrome
             **/
            function _safariPrivateTest() {
              _safariPrivateTest = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
                var _navigator$storage;
                return _regenerator["default"].wrap(function (_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!(typeof ((_navigator$storage = navigator.storage) === null || _navigator$storage === void 0 ? void 0 : _navigator$storage.getDirectory) === 'function')) {
                        _context2.next = 2;
                        break;
                      }
                      _context2.next = 1;
                      return currentSafariTest();
                    case 1:
                      _context2.next = 3;
                      break;
                    case 2:
                      if (navigator.maxTouchPoints !== undefined) {
                        safari13to18Test();
                      } else {
                        oldSafariTest();
                      }
                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return _safariPrivateTest.apply(this, arguments);
            }
            function getQuotaLimit() {
              var _w$performance$memory, _w$performance;
              var w = window;
              return (_w$performance$memory = w === null || w === void 0 || (_w$performance = w.performance) === null || _w$performance === void 0 || (_w$performance = _w$performance.memory) === null || _w$performance === void 0 ? void 0 : _w$performance.jsHeapSizeLimit) !== null && _w$performance$memory !== void 0 ? _w$performance$memory : 1073741824;
            }

            // >= 76
            function storageQuotaChromePrivateTest() {
              navigator.webkitTemporaryStorage.queryUsageAndQuota(function (_, quota) {
                var quotaInMib = Math.round(quota / (1024 * 1024));
                var quotaLimitInMib = Math.round(getQuotaLimit() / (1024 * 1024)) * 2;
                __callback(quotaInMib < quotaLimitInMib);
              }, function (e) {
                reject(new Error('detectIncognito somehow failed to query storage quota: ' + e.message));
              });
            }

            // 50 to 75
            function oldChromePrivateTest() {
              var fs = window.webkitRequestFileSystem;
              var success = function success() {
                __callback(false);
              };
              var error = function error() {
                __callback(true);
              };
              fs(0, 1, success, error);
            }
            function chromePrivateTest() {
              if (self.Promise !== undefined && self.Promise.allSettled !== undefined) {
                storageQuotaChromePrivateTest();
              } else {
                oldChromePrivateTest();
              }
            }

            /**
             * Firefox
             **/
            function firefoxPrivateTest() {
              return _firefoxPrivateTest.apply(this, arguments);
            }
            /**
             * MSIE
             **/
            function _firefoxPrivateTest() {
              _firefoxPrivateTest = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                var _navigator$storage2;
                var message, matchesExpectedError, request, _t2;
                return _regenerator["default"].wrap(function (_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      if (!(typeof ((_navigator$storage2 = navigator.storage) === null || _navigator$storage2 === void 0 ? void 0 : _navigator$storage2.getDirectory) === 'function')) {
                        _context3.next = 5;
                        break;
                      }
                      _context3.prev = 1;
                      _context3.next = 2;
                      return navigator.storage.getDirectory();
                    case 2:
                      __callback(false);
                      _context3.next = 4;
                      break;
                    case 3:
                      _context3.prev = 3;
                      _t2 = _context3["catch"](1);
                      message = _t2 instanceof Error && typeof _t2.message === 'string' ? _t2.message : String(_t2);
                      matchesExpectedError = message.includes('Security error');
                      __callback(matchesExpectedError);
                      return _context3.abrupt("return");
                    case 4:
                      _context3.next = 6;
                      break;
                    case 5:
                      request = indexedDB.open('inPrivate');
                      request.onerror = function (event) {
                        if (request.error && request.error.name === 'InvalidStateError') {
                          event.preventDefault();
                        }
                        __callback(true);
                      };
                      request.onsuccess = function () {
                        indexedDB.deleteDatabase('inPrivate');
                        __callback(false);
                      };
                    case 6:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3, null, [[1, 3]]);
              }));
              return _firefoxPrivateTest.apply(this, arguments);
            }
            function msiePrivateTest() {
              __callback(window.indexedDB === undefined);
            }
            function main() {
              return _main.apply(this, arguments);
            }
            function _main() {
              _main = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
                return _regenerator["default"].wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      if (!isSafari()) {
                        _context4.next = 2;
                        break;
                      }
                      browserName = 'Safari';
                      _context4.next = 1;
                      return safariPrivateTest();
                    case 1:
                      _context4.next = 6;
                      break;
                    case 2:
                      if (!isChrome()) {
                        _context4.next = 3;
                        break;
                      }
                      browserName = identifyChromium();
                      chromePrivateTest();
                      _context4.next = 6;
                      break;
                    case 3:
                      if (!isFirefox()) {
                        _context4.next = 5;
                        break;
                      }
                      browserName = 'Firefox';
                      _context4.next = 4;
                      return firefoxPrivateTest();
                    case 4:
                      _context4.next = 6;
                      break;
                    case 5:
                      if (isMSIE()) {
                        browserName = 'Internet Explorer';
                        msiePrivateTest();
                      } else {
                        reject(new Error('detectIncognito cannot determine the browser'));
                      }
                    case 6:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return _main.apply(this, arguments);
            }
            main()["catch"](reject);
          });
        case 1:
          return _context5.abrupt("return", _context5.sent);
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _detectIncognito.apply(this, arguments);
}
if (typeof window !== 'undefined') {
  window.detectIncognito = detectIncognito;
}
var _default = exports["default"] = detectIncognito;